<template>
    <div class="col backgroundForm">
        <div class="col-md-6 offset-md-3">
            <div class="alert alert-info" align="center" role="alert">
                <h4 class="alert-heading">Listado de Empresas Autorizadas</h4>
                <p>Realiza el listado de Empresas Registradas y sus respectivas Autorizaciones y Servicios Información Obtenida de la Unidad de Puertos y Vias</p>       
            </div>
        </div>
        
        <button class="btn btn-success col-12 col-md-4 offset-md-4" :disabled="animate" @click="mUpdateStateEmpresas"><font-awesome-icon :spin="animate" icon="sync-alt" /> Actualizar Vigencias </button>
        <br><br>
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#list-empresa" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="list" /> Reporte de Empresas</a>
                <a class="nav-item nav-link" id="nav-capitan-list" data-toggle="tab" href="#list-muelles" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="list" /> Listado de Muelles/Atracaderos</a>
            </div>
        </nav>
                
        <div class="tab-content" id="nav-tabContent">                
            <div class="tab-pane fade show active" id="list-empresa" role="tabpanel" aria-labelledby="nav-new-tab" >
                <br>
                        
                <h6 align="center">Listado de Empresas Registradas, Certificados de Autorizacion y Servicios que prestan</h6>
                <hr>
                        <!-- embarcacion encontrada -->
                            <div class="input-group col-12">
                                    <div class="input-group-append">
                                        <span class="input-group-text">Número de Registros</span>
                                    </div>
                                    <input type="number" min="1" class="form-control" v-model="cantidad_reg">
                                    <button class="btn btn-info" @click="mChargeCertificatesEmpresa( cantidad_reg)">
                                        Listar
                                    </button>
                            </div>
                            <transition name="fade" mode="out-in">
                                    <table class="table sm" v-if="certificatesEmpresa.length>0">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Empresa/Certificado</th>
                                            <th>Vigencia</th>
                                            <th>Cuenca</th>
                                            <th>Servicio</th>
                                            <th>Estado</th>

                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="cem, index in certificatesEmpresa" :key="cem.id">
                                                <td>{{ index+1 }}</td>
                                                <td>{{ cem.nombre_propietario }} <br> {{ cem.numero_certificado }}</td>
                                                <td>{{ $dateWrite(cem.fecha_inicio) }} al {{ $dateWrite(cem.fecha_vencimiento) }}</td>
                                                <td>{{ cem.cuenca }}<br>{{ cem.detalle_puerto }}<br>{{ cem.nombre_muelle }}</td>
                                                <td>{{ cem.servicio_presta }}</td>
                                                <td class="alert" :class="'alert-'+cem.estilo">{{ cem.estado_certificado}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                        </transition>
                        
            </div>
            <!-- end first tab -->

            <div class="tab-pane fade" id="list-muelles" role="tabpanel" aria-labelledby="nav-new-tab" >
                <br>

                <h6 align="center">Listado de Puertos/Muelles/Atracaderos Registrados en cada cuenca</h6>
                <hr>
                <button class="btn btn-info col-12 col-md-4 offset-md-4" @click="mCallPortsList()">
                    Listar Puertos Muelles
                </button>
                
                <transition name="fade" mode="out-in">
                    <table class="table sm" v-if="portsMuelles.length>0">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Cuenca</th>
                                <th>Puerto</th>
                                <th>Muelle/Atracadero</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="pma, index in portsMuelles" :key="pma.id">
                                <td>{{ index+1 }}</td>
                                <td>{{ pma.cuenca_detalle}}</td>
                                <td>{{ pma.detalle_puerto }}</td>
                                <td>{{ pma.nombre_muelle }}</td>
                                <td>{{ pma.estado_muelle ==='A' ? 'ACTIVO':'INACTIVO' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </transition>        
            </div>
            <!-- end first tab -->
    
        </div>
        <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
        <modal-report :id-modal-report="id_modal_r" :title="modal_report_t" :content="modal_report_c" :url-r="modal_report_url" :id-report="id_report"></modal-report>
    </div>
    </template>
    
    <script>
    import Vue from 'vue';
    import axios from 'axios';
    const qs = require('qs');
    
    import modalLoading from '../modal/modalLoading';
    import modalReport from '../modal/modalReport.vue';
    
    export default {
        name:'report-list-uumm',
        data(){
            return{
                cantidad_reg:20,
                id_modal_r:'reportuumm',
                modal_report_t:'Certificados UUMM',
                modal_report_url:'pdfuumm',
                id_report:0,
                modal_report_c:null,
                certificatesEmpresa:[],
                animate:false,
                portsMuelles:[],
                status_send:false,
                modal_load_title:'Cargando',
                modal_load_id:'id_modal_empresas'
            }
        },
        mounted(){
            // if(Vue.auth.getToken()){
            //     axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;
            // }
            // console.log(axios.defaults.headers)
            this.mCallInit();
        },
        methods:{
            async mCallPortsList(){
                let muelle_aux = await axios.get(`getMuellesRegisters/active?api_token=${Vue.auth.getToken()}`);
                console.log(muelle_aux);
                this.portsMuelles=muelle_aux.data;
                console.log(this.portsMuelles);
            },
            async mUpdateStateEmpresas(){
                let auxUpdateStateEmpresas=await axios.get(`getUpdateStateEmpresas?api_token=${Vue.auth.getToken()}`);
                console.log(auxUpdateStateEmpresas);
                if(auxUpdateStateEmpresas.data[0].status){
                    toastr.success(auxUpdateStateEmpresas.data[0].respuesta, 'Exito');
                }else{
                    toastr.error(auxUpdateStateEmpresas.data[0].respuesta, 'Error');
                }
                this.mChargeCertificatesEmpresa();
            },
            async mCallInit(){
                this.muelles_lista=[];
                let muelle_call=await axios.get(`getMuellesRegisters/active?api_token=${Vue.auth.getToken()}`);

                this.muelles_lista=muelle_call.data;
            },
            mShowModalUP(idM){
                $('#'+idM).modal('show');
            },
            mCloseModalUP(idM){
                $('#'+idM).modal('hide');
            },
            async mChargeCertificatesEmpresa(quantity=20){
                this.certificatesEmpresa=[];
                quantity=quantity>0?quantity:5;
                let registrosOld=await axios.get(`getListAutorizacionEmpresa/0/${quantity}?api_token=${Vue.auth.getToken()}`);

                if(registrosOld.data.length>0){
                    registrosOld.data.forEach((dte)=>{
                        let aux_state,estilo;
                        switch(dte.estado_certificado){
                            case 'A':
                                aux_state='ACTIVO';
                                estilo='success'
                                break;
                            case 'I':
                                aux_state='INACTIVO';
                                estilo='danger'
                                break;
                            case 'V':
                                aux_state='VENCIDO';
                                estilo='warning'
                                break;
                        }
                        let aux_cert={
                            cuenca:dte.cuenca,
                            dato_identificacion:dte.dato_identificacion,
                            nombre_propietario:dte.nombre_propietario,
                            detalle_puerto:dte.detalle_puerto,
                            estado_certificado:aux_state,
                            fecha_inicio:dte.fecha_inicio,
                            fecha_vencimiento:dte.fecha_vencimiento,
                            id:dte.id,
                            nombre_muelle:dte.nombre_muelle,
                            nombre_propietario:dte.nombre_propietario,
                            numero_certificado:dte.numero_certificado,
                            servicio_presta:dte.servicio_presta,
                            estilo:estilo
                        }
                        this.certificatesEmpresa.push(aux_cert);
                    })
                }else{
                    toastr.warning('No existen registros de Empresas Activas o Vencidas');
                }
                // this.certificatesEmpresa=registrosOld.data;
            }
        },
        components:{
            'modal-loading':modalLoading,
            'modal-report':modalReport
        },
        computed:{
            
        },
        filters:{
            upperCase(value){
                return value.toUpperCase();
            }
        }
    }
    </script>
    
    <style>
        .required-text{
            color:red; 
            font-weight:bold;
        }
    </style>
    


// WEBPACK FOOTER //
// src/components/uumm/ReportListEmpresas.vue